import React, { lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FomoTicker from "@/components/FomoTicker";
import ExitIntentModal from "@/components/ExitIntentModal";

const HomePage = lazy(() => import("@/pages/HomePage"));
const AgendaPage = lazy(() => import("@/pages/AgendaPage"));
const SpeakersPage = lazy(() => import("@/pages/SpeakersPage"));
const AwardsPage = lazy(() => import("@/pages/AwardsPage"));
const ExpoPage = lazy(() => import("@/pages/ExpoPage"));
const RegisterPage = lazy(() => import("@/pages/RegisterPage"));
const SponsorPage = lazy(() => import("@/pages/SponsorPage"));
const ContactPage = lazy(() => import("@/pages/ContactPage"));
const AdminLoginPage = lazy(() => import("@/pages/AdminLoginPage"));
const AdminPage = lazy(() => import("@/pages/AdminPage"));
const ConfirmationPage = lazy(() => import("@/pages/ConfirmationPage"));
const BlogListPage = lazy(() => import("@/pages/BlogListPage"));
const BlogArticlePage = lazy(() => import("@/pages/BlogArticlePage"));
const ThankYouPage = lazy(() => import("@/pages/ThankYouPage"));

const Loader = () => (
  <div className="min-h-screen bg-forest-core flex items-center justify-center">
    <div className="w-8 h-8 border-2 border-lemon-beam border-t-transparent rounded-full animate-spin" />
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <div className="font-inter">
          <Suspense fallback={<Loader />}>
            <Routes>
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/register/confirmation/:bookingRef" element={<><Navbar /><ConfirmationPage /><Footer /></>} />
              <Route path="/register/confirmation" element={<><Navbar /><ConfirmationPage /><Footer /></>} />
              <Route path="/*" element={
                <>
                  <Navbar />
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/agenda" element={<AgendaPage />} />
                    <Route path="/speakers" element={<SpeakersPage />} />
                    <Route path="/awards" element={<AwardsPage />} />
                    <Route path="/expo" element={<ExpoPage />} />
                    <Route path="/register" element={<RegisterPage />} />
                    <Route path="/sponsor" element={<SponsorPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/blog" element={<BlogListPage />} />
                    <Route path="/blog/:slug" element={<BlogArticlePage />} />
                    <Route path="/thank-you" element={<ThankYouPage />} />
                  </Routes>
                  <Footer />
                  <FomoTicker />
                  <ExitIntentModal />
                </>
              } />
            </Routes>
          </Suspense>
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
